import { useState } from 'react';
import QRModal from './QRModal.jsx';
import { tagColor } from '../utils/tagColor.js';

const COLOR = {
  blue:    { border: 'border-slate-200', strip: 'bg-indigo-500',  text: 'text-indigo-700',  tag: 'bg-indigo-50 text-indigo-700 border-indigo-100',     btn: 'bg-indigo-600 hover:bg-indigo-700'   },
  teal:    { border: 'border-slate-200', strip: 'bg-teal-500',    text: 'text-teal-700',    tag: 'bg-teal-50 text-teal-700 border-teal-100',           btn: 'bg-teal-600 hover:bg-teal-700'       },
  green:   { border: 'border-slate-200', strip: 'bg-emerald-500', text: 'text-emerald-700', tag: 'bg-emerald-50 text-emerald-700 border-emerald-100',   btn: 'bg-emerald-600 hover:bg-emerald-700'  },
  yellow:  { border: 'border-slate-200', strip: 'bg-amber-400',   text: 'text-amber-700',   tag: 'bg-amber-50 text-amber-700 border-amber-100',         btn: 'bg-amber-500 hover:bg-amber-600'      },
  red:     { border: 'border-slate-200', strip: 'bg-red-500',     text: 'text-red-700',     tag: 'bg-red-50 text-red-700 border-red-100',               btn: 'bg-red-600 hover:bg-red-700'          },
  pink:    { border: 'border-slate-200', strip: 'bg-pink-500',    text: 'text-pink-700',    tag: 'bg-pink-50 text-pink-700 border-pink-100',             btn: 'bg-pink-600 hover:bg-pink-700'        },
  purple:  { border: 'border-slate-200', strip: 'bg-violet-500',  text: 'text-violet-700',  tag: 'bg-violet-50 text-violet-700 border-violet-100',       btn: 'bg-violet-600 hover:bg-violet-700'    },
  orange:  { border: 'border-slate-200', strip: 'bg-orange-500',  text: 'text-orange-700',  tag: 'bg-orange-50 text-orange-700 border-orange-100',       btn: 'bg-orange-500 hover:bg-orange-600'    },
  cyan:    { border: 'border-slate-200', strip: 'bg-sky-500',     text: 'text-sky-700',     tag: 'bg-sky-50 text-sky-700 border-sky-100',               btn: 'bg-sky-500 hover:bg-sky-600'          },
  lime:    { border: 'border-slate-200', strip: 'bg-lime-500',    text: 'text-lime-700',    tag: 'bg-lime-50 text-lime-700 border-lime-100',             btn: 'bg-lime-600 hover:bg-lime-700'        },
  rose:    { border: 'border-slate-200', strip: 'bg-rose-500',    text: 'text-rose-700',    tag: 'bg-rose-50 text-rose-700 border-rose-100',             btn: 'bg-rose-600 hover:bg-rose-700'        },
  fuchsia: { border: 'border-slate-200', strip: 'bg-fuchsia-500', text: 'text-fuchsia-700', tag: 'bg-fuchsia-50 text-fuchsia-700 border-fuchsia-100',   btn: 'bg-fuchsia-600 hover:bg-fuchsia-700'  },
};

function isPdfUrl(url) {
  return url.startsWith('/api/files/') || url.toLowerCase().includes('.pdf');
}

function isGoogleDocsUrl(url) {
  return url.includes('docs.google.com') || url.includes('sheets.google.com') || url.includes('slides.google.com');
}

function downloadUrl(url) {
  return url.startsWith('/api/files/') ? `${url}?dl=1` : url;
}

export default function LinkCard({ item, onView }) {
  const [qrOpen, setQrOpen] = useState(false);
  const c = COLOR[tagColor(item.tag) || item.color] || COLOR.blue;
  const url = item.url || item.gem_url || '';
  const isPdf = url ? isPdfUrl(url) : false;
  const hasContent = item.content || url;

  return (
    <>
      <div className={`rounded-2xl border ${c.border} bg-white shadow-card hover:shadow-card-hover transition-shadow overflow-hidden flex flex-col`}>
        {/* colored top strip */}
        <div className={`h-1 ${c.strip}`} />

        <div className="p-4 flex flex-col gap-3 flex-1">
          <div className="flex items-start gap-3">
            {item.icon && (
              <span className="text-2xl leading-none mt-0.5 flex-shrink-0">{item.icon}</span>
            )}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap mb-0.5">
                <h3 className={`font-bold text-base ${c.text} leading-snug`}>{item.name}</h3>
                {item.tag && (
                  <span className={`text-xs px-2 py-0.5 rounded-full border ${c.tag} font-medium`}>
                    {item.tag}
                  </span>
                )}
                {isPdf && (
                  <span className="text-xs px-1.5 py-0.5 rounded bg-red-50 text-red-600 border border-red-100 font-medium">PDF</span>
                )}
              </div>
              {item.desc && <p className="text-sm text-slate-500 leading-relaxed">{item.desc}</p>}
            </div>
          </div>

          {!isPdf && url && isGoogleDocsUrl(url) && (
            <div className="flex items-start gap-1.5 px-3 py-2 bg-blue-50 border border-blue-100 rounded-xl text-xs text-blue-700">
              <svg className="w-3.5 h-3.5 mt-0.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>閲覧専用です。編集するには開いた後「ファイル → コピーを作成」で自分のファイルとして保存してください。</span>
            </div>
          )}
          {hasContent && (
            <div className="flex gap-2 flex-wrap mt-auto pt-1">
              {onView && (item.content || url) ? (
                <>
                  <button
                    onClick={onView}
                    className={`flex-1 text-center text-sm font-medium py-2 px-3 rounded-xl text-white ${c.btn} transition-colors min-w-0 cursor-pointer`}
                  >
                    表示
                  </button>
                  {isPdf && (
                    <a
                      href={downloadUrl(url)}
                      download
                      className="flex items-center gap-1 px-3 py-2 rounded-xl bg-white border border-slate-200 text-slate-600 text-sm font-medium hover:bg-slate-50 transition-colors"
                      title="PDFをダウンロード"
                    >
                      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                      </svg>
                      DL
                    </a>
                  )}
                </>
              ) : (
                <>
                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`flex-1 text-center text-sm font-medium py-2 px-3 rounded-xl text-white ${c.btn} transition-colors min-w-0`}
                  >
                    {isPdf ? '開く・印刷' : '開く'}
                  </a>
                  {isPdf && (
                    <a
                      href={downloadUrl(url)}
                      download
                      className="flex items-center gap-1 px-3 py-2 rounded-xl bg-white border border-slate-200 text-slate-600 text-sm font-medium hover:bg-slate-50 transition-colors"
                      title="PDFをダウンロード"
                    >
                      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                      </svg>
                      DL
                    </a>
                  )}
                  <button
                    onClick={() => setQrOpen(true)}
                    title="QRコードを表示"
                    className="px-3 py-2 rounded-xl bg-white border border-slate-200 text-slate-500 hover:border-slate-300 hover:text-slate-700 transition-colors cursor-pointer"
                  >
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                        d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
                    </svg>
                  </button>
                </>
              )}
            </div>
          )}
        </div>
      </div>

      {qrOpen && url && (
        <QRModal url={url} name={item.name} onClose={() => setQrOpen(false)} />
      )}
    </>
  );
}
